<template>
  <div class="date-q">
    <date-time-year
      v-if="issue.dateType === 'year'"
      :max-time="issue.max"
      :min-time="issue.min"
      v-model="issue.value"
      :range="issue.range"
      :validate-type="issue.validateType"
    />
    <date-time-month
      v-else-if="issue.dateType === 'month'"
      :max-time="issue.max"
      :min-time="issue.min"
      v-model="issue.value"
      :range="issue.range"
      :validate-type="issue.validateType"
    />
    <date-time-minute
      v-else-if="issue.dateType === '分'"
      :max-time="issue.max"
      :min-time="issue.min"
      v-model="issue.value"
      :range="issue.range"
      :validate-type="issue.validateType"
    />
    <date-time-second
      v-else-if="issue.dateType === '秒'"
      :max-time="issue.max"
      :min-time="issue.min"
      v-model="issue.value"
      :range="issue.range"
      :validate-type="issue.validateType"
    />
    <date-time-hour
      v-else
      :max-time="issue.max"
      :min-time="issue.min"
      v-model="issue.value"
      :range="issue.range"
      :validate-type="issue.validateType"
    />
  </div>
</template>

<script>
import DateTimeHour from '@/questions/components/datetime/DateTimeHour'
import DateTimeMinute from '@/questions/components/datetime/DateTimeMinute'
import DateTimeSecond from '@/questions/components/datetime/DateTimeSecond'
import DateTimeMonth from '@/questions/components/datetime/DateTimeMonth'
import DateTimeYear from '@/questions/components/datetime/DateTimeYear'

export default {
  name: 'DateQ',
  changeExpr: 'changeExpr',
  components: { DateTimeYear, DateTimeMonth, DateTimeSecond, DateTimeMinute, DateTimeHour },
  data() {
    return {
      popup: false,
      value: null,
      minDate: null,
      maxDate: null
    }
  },
  created() {},
  computed: {
    changeExpr() {
      return this.issue.value
    }
  },
  methods: {}
}
</script>
